import config from 'src/config';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { getData, patchData, postData } from 'src/utils/axios/serverHelper';
import { TQC5020_R01HeaderDto, TQC5020_R01DetailDto } from './Dto_TQC5020_R01';
import { TQC5020_R01Filter } from './Store_TQC5020_R01';

const baseUrl = `${config.apiUrl}/TQC5020_R01`;

export const getTQC5020_R01List = async (params: Partial<TQC5020_R01Filter>) =>
	getData<ResponseDto<TQC5020_R01HeaderDto[]>>(`${baseUrl}/item`, { params });

export const getTQC5020_R01SpecList = async (itemGroup: string, itemCd: string, inspType?: string) =>
	getData<ResponseDto<TQC5020_R01DetailDto[]>>(`${baseUrl}/spec`, {
		params: { itemGroup, itemCd, inspType: inspType || undefined },
	});

export const patchTQC5020_R01SpecList = async (dtoList: TQC5020_R01DetailDto[]) =>
	patchData<TQC5020_R01DetailDto[], ResponseDto<TQC5020_R01DetailDto[]>>(`${baseUrl}/spec`, dtoList);

export const postTQC5020_R01NewInspectItem = async (dto: TQC5020_R01DetailDto) =>
	postData<TQC5020_R01DetailDto, ResponseDto<TQC5020_R01DetailDto>>(`${baseUrl}/new-item`, dto);
